var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import FieldContext from './FieldContext';
import { formFieldProps } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
var Field = /** @class */ (function (_super) {
    __extends(Field, _super);
    function Field(props) {
        var _this = _super.call(this, props) || this;
        /**
         * children添加value属性和onChange事件
         */
        _this.getControlled = function (children) {
            var _a = _this.context, getFieldValue = _a.getFieldValue, setFieldsValue = _a.setFieldsValue;
            var name = _this.props.name;
            var type = children.type.NAME;
            return {
                value: getFieldValue(name),
                onChange: function (event) {
                    var _a;
                    var newValue = event;
                    switch (type) {
                        case 'checkbox':
                            newValue = event.target.value;
                            break;
                        default:
                    }
                    setFieldsValue((_a = {}, _a[name] = newValue, _a));
                },
            };
        };
        _this.onStoreChange = function () {
            _this.forceUpdate();
        };
        _this.renderLayout = function (childNode) {
            var _a = _this.props, label = _a.label, name = _a.name, _b = _a.rules, rules = _b === void 0 ? [{ required: false, message: '' }] : _b, className = _a.className, rest = __rest(_a, ["label", "name", "rules", "className"]);
            var itemAtomics = [
                'flex',
                'items-center',
                'mb-px-16',
                'min-h-px-54',
                'pt-px-12',
            ];
            var errMsgAtomics = ['text-sm', 'text-error-900', 'leading-4', 'pt-px-4'];
            var item = _this.context.errList.length > 0 &&
                _this.context.errList.filter(function (item) {
                    return item.field === name;
                });
            var starPositon = _this.context.starPositon;
            var renderStar = rules.length > 0 && rules[0].required && (React.createElement("i", { className: "text-error-900 mr-px-4" }, "*"));
            var renderLabel = starPositon === 'Right' ? (React.createElement(React.Fragment, null,
                label,
                renderStar)) : (React.createElement(React.Fragment, null,
                renderStar,
                label));
            return (React.createElement(DivTag, __assign({ className: "" + className, atomics: itemAtomics }, rest, { autoPrefixedClassName: "form-item" }),
                label && React.createElement("label", { className: "form-label" }, renderLabel),
                React.createElement("div", { className: "form-cont" },
                    childNode,
                    item.length > 0 && React.createElement(DivTag, { atomics: errMsgAtomics }, item[0].message))));
        };
        return _this;
    }
    Field.prototype.componentDidMount = function () {
        // 注册组件实例到FormStore
        this.cancelRegister = this.context.registerField(this);
    };
    Field.prototype.componentWillUnmount = function () {
        // 取消注册
        if (this.cancelRegister) {
            this.cancelRegister();
        }
    };
    Field.prototype.render = function () {
        var children = this.props.children;
        var c = Array.isArray(children) ? children[0] : children;
        var returnChildNode = React.cloneElement(c, this.getControlled(c));
        return this.renderLayout(returnChildNode);
    };
    Field.defaultProps = formFieldProps;
    Field.contextType = FieldContext;
    return Field;
}(React.Component));
export default Field;
